module.exports = __webpack_public_path__ + "images/8528a5484326b3eef06b6dfcc6ce25bd-Roboto-Regular.svg";